<template>
    <div ref="carousel"
         class="carousel"
         v-if="data.length">
        <h2>滚动 <span style="color:red">大图</span></h2>
        <el-carousel :height="height">
            <el-carousel-item v-for="(item, index) in data"
                              :key="index">
                <a :href="item.url"
                   target="_blank">
                    <Image1 :src="item.image"
                            scale="16:9">
                    </Image1>
                    <span class="title">{{item.title}}</span>
                </a>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
import Image1 from "../image";
export default {
    name: "Carousel",
    components: {
        Image1
    },
    data () {
        return {
            height: "100%",
        }
    },
    props: {
        data: Array
    },
    updated () {
        this.height = Number(this.$refs["carousel"].clientWidth) * (9 / 16) + "px"
    }
}
</script>

<style scoped>
.carousel {
    margin: 0.3rem;
}
h2 {
    text-align: center;
    font-weight: 1000;
    margin: 0.3rem;
    margin-bottom: 0;
}

.title {
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    bottom: 0;
    padding: 6px 80px 6px 6px;
    width: calc(100% - 80px);
    color: #fff;
    display: block;
    word-wrap: normal;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.carousel >>> .el-carousel .el-carousel__button {
    width: 6px;
    height: 6px;
    border-radius: 50%;
}

.carousel >>> .el-carousel__indicators--horizontal {
    left: unset !important;
    right: 0 !important;
    transform: unset;
}

.carousel >>> .el-carousel__indicator--horizontal {
    padding: 8px 4px !important;
}
</style>
